export default class DeliveryPriceManagementService {
    constructor($http, appConfig) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
    }
  
    addDeliveryPrice(deliveryPrice) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/deliveryprices/add`, deliveryPrice);
    }
  
    listDeliveryPrices(entityId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/deliveryprices/list/${entityId}`);
    }
  
    removeDeliveryPrice(entityId, deliveryPriceId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/deliveryprices/remove/${entityId}/${deliveryPriceId}`);
    }

    getDeliveryPrice(entityId, deliveryPriceId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/deliveryprices/get/${entityId}/${deliveryPriceId}`);
    }    
  }
  


// WEBPACK FOOTER //
// ./client/app/components/admin/deliveryPriceManagement/deliveryPriceManagement.service.js